/** @module csi/action/ImageReplace */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/ViewRef",
	"csi/heading/AttributeAction",
	"csi/reflection",
	"csi/xml"
], function(declare, lang, ViewRef, AttributeAction, reflection, xml) {

	return declare(AttributeAction, {
		classController: "csi.action.ImageReplaceController",
		classControllerParams: {
			popupForceBrowse: true
		},
		m_id: "ImageReplace",

		/**@property {string} unlinkURL - This is ImageContainer for Unlink operation */
		unlinkURL: "",

		/**
		 * Check access to action based on given context
		 * @param {Context} ctx
		 * @return {boolean}
		 */
		hasAccess: function(ctx) {
			var node = ctx.getNode();
			var bImage = (node[xml.ATTR_TYPE] == reflection.TYPE_IMAGE);
			var imageNode = bImage ? node : ctx.cache.getNode(this.m_viewRef.m_url);
			return imageNode && !imageNode.GeneratedBy && !node.Is3D && this.inherited(arguments);
		},

		/**
		 * Perform initialization, assign image node cnl and use count for the image
		 * @param {string} url - cnl of image node
		 * @param {string} unlinkURL - node for unlink operation
		 * @param {Heading} h - heading for AttributeImage
		 * @return {ImageReplace} - return self
		 */
		init: function(url, unlinkURL, h) {
			this.unlinkURL = unlinkURL;
			this.heading = h;
			this.m_viewRef = lang.mixin(new ViewRef(), {
				m_id: "ImageReplace",
				m_url: url
			});
			this.resolve();
			this.setBaseRights(xml.RIGHT_WRITE);

			// set return parameters so that view will query for new data as the ReplaceImage operation does not return all changes;
			// and it probably shouldn't since the image could be replaced on many nodes
			this.setReturnParameters({
				"Dep.Path": xml.path(reflection.ATTR_IMAGES)
			});

			return this;
		}
	});
});